import bizNodeModel from '../../bizNodeModel.mjs'
import BdType from './BdType.mjs'

export default bizNodeModel({
    bmCode: {
        name: () => '业务域',
        hidden: (map, node) => 'BODA1' !== map.data.subTypeCode,
    },

    bdName: {
        name: (map, node) => {
            const {subTypeCode} = map.data
            return 'BODA1' === subTypeCode ? '业务能力模块名称' : '程序模块名称'
        },

        required: () => true,
    },

    bdNo: {
        name: (map, node) => {
            const {subTypeCode} = map.data
            return 'BODA1' === subTypeCode ? '业务能力模块代码' : '程序模块代码'
        },

        required: () => true,
    },

    bdType: {
        name: (map, node) => {
            const {subTypeCode} = map.data
            return 'BODA1' === subTypeCode ? '业务能力模块类型' : '程序模块类型'
        },

        readableValue: (map, node) => {
            const {bdType} = node.data

            if (bdType) {
                const match = BdType.find(e => bdType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    fmCode: {
        name: () => '功能域',
        hidden: (map, node) => 'BODA1' === map.data.subTypeCode,
    },

    memo: {
        name: () => '备注',
    },

    ssCode: {
        name: () => '子系统',
    },

    vmCode: {
        name: () => '程序域',
    },
})
